import React from 'react';
import Navbar from './global-components/navbar';

import NEETDetails from './section-components/neet-details';
import Footer from './global-components/footer-v2';
import {Helmet} from "react-helmet";
import Page_header from './global-components/page-headerneet';

const NEET = () => {
    return <div>
        <Navbar />
        <Helmet>
            <title>Best NEET Coaching in Chennai | MIET Education, Kodambakkam</title>
            <meta name="description" content="MIET Education in Kodambakkam, Chennai, offers the best NEET coaching with expert faculty, comprehensive study materials, and a proven track record of success." />
        </Helmet>
        {/* <PageHeader headertitle="NEET"  /> */}
        <Page_header headertitle="NEET" />
        <NEETDetails />
        <Footer />
    </div>
}

export default NEET